import React, { ReactElement } from 'react';
import { AccordionSection } from './AccordionSection';
import { AccordionItem } from './AccordionItem';

type AccordionProps = {
  onChange?: (event: { title: string, index: number, expanded: number[] }) => void;
  onSectionExpanded?: (event: { title: string, index: number }) => void;
  onSectionCollapsed?: (event: { title: string, index: number }) => void;
  expanded: number[],
  children: React.ReactNode[];
};

export const BaseAccordion: React.FC<AccordionProps> = ({
  children,
  expanded,
  onChange,
  onSectionExpanded,
  onSectionCollapsed,
}) => {
  const toggleHandler = ({ title, index }) => {
    const currentlyExpanded = expanded.indexOf(index) > -1 || false;
    let newExpanded = [...expanded];

    if (currentlyExpanded === false) {
      newExpanded.push(index);
      if (onSectionExpanded) {
        onSectionExpanded({
          title,
          index,
        });
      }
    } else {
      newExpanded = expanded.filter(idx => idx !== index);
      if (onSectionCollapsed) {
        onSectionCollapsed({
          title,
          index,
        });
      }
    }

    if (onChange) {
      onChange({
        title,
        index,
        expanded: newExpanded,
      });
    }
  };

  return (
    <React.Fragment>
      {React.Children.map(children,
        (child: ReactElement, index) => {
          if (child.type === AccordionSection) {
            return React.cloneElement(child, {
              index,
              onToggleSection: toggleHandler,
              expand: expanded.indexOf(index) !== -1,
            });
          }

          return child;
        })}
    </React.Fragment>
  );
};

BaseAccordion.defaultProps = {
  expanded: [],
};

export const Accordion = Object.assign(BaseAccordion, {
  Section: AccordionSection,
  Item: AccordionItem,
});

export default Accordion;
